import React from 'react';
import { SnippetTextArea } from '../SnippetTextArea';
import { intl } from '@fullstory/intl';

const exampleScriptComment = intl.formatMessage({
  defaultMessage: "This is an example script - don't forget to change it!",
  id: 'qG2IqD',
});

const todoComment = intl.formatMessage({
  defaultMessage: 'Add your own custom user variables here, details at',
  description:
    'The at at the end of this sentence is followed up with a link to help documentation.',
  id: 'fNF7n1',
});

const snippet = `// ${exampleScriptComment}
FS('setIdentity', {
  uid: '<THE_ID_THAT_YOU_USE_IN_YOUR_APP_FOR_THIS_USER>',
  properties: {
    displayName: '<DISPLAY_NAME_HERE>',
    email: '<EMAIL_HERE>',
    // ${todoComment}
    // https://developer.fullstory.com/browser/identification/set-user-properties/
    reviewsWritten: 14
  }
});`;

type IdentifySnippetProps = Pick<
  React.ComponentProps<typeof SnippetTextArea>,
  'onCopyButtonClicked'
>;

export const IdentifySnippet: React.FC<IdentifySnippetProps> = props => (
  <SnippetTextArea {...props} snippet={snippet} />
);
